
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.583 17.5h.834v-2.083H17.5v-.834h-2.083V12.5h-.834v2.083H12.5v.834h2.083V17.5zM15 19.167c-1.153 0-2.135-.407-2.948-1.22-.812-.812-1.219-1.794-1.219-2.947s.407-2.135 1.22-2.948c.812-.812 1.794-1.219 2.947-1.219s2.135.407 2.948 1.22c.812.812 1.219 1.794 1.219 2.947s-.407 2.135-1.22 2.948c-.812.812-1.794 1.219-2.947 1.219zM5.833 7.5h8.334V5.833H5.833V7.5zm3.896 10H4.167c-.459 0-.851-.163-1.177-.49a1.605 1.605 0 01-.49-1.177V4.167c0-.459.163-.851.49-1.177.326-.327.718-.49 1.177-.49h11.666c.459 0 .851.163 1.177.49.327.326.49.718.49 1.177V9.75a5.971 5.971 0 00-1.219-.438A5.532 5.532 0 0015 9.168c-.153 0-.295.003-.427.01a2.83 2.83 0 00-.406.052v-.062H5.833v1.666h5.104c-.25.236-.475.493-.677.771a5.741 5.741 0 00-.53.896H5.832v1.667H9.23a2.83 2.83 0 00-.052.406c-.007.132-.01.274-.01.427 0 .458.041.885.125 1.281.083.396.229.802.437 1.219z"}})])
          )
        }
      }
    